import {
  primaryColor,
  dangerColor,
  successColor,
  grayColor,
  defaultFont,
} from "assets/jss/material-dashboard-react.js";

const customInputStyle = (theme) => ({
  disabled: {
    backgroundColor: "rgb(0,0,0,0.1)",
    "&:before": {
      backgroundColor: "transparent !important",
    },
  },
  underline: {
    border: 0,
    borderRadius: 5,
    "&:hover:not($disabled):before,&:before": {
      borderColor: "#A5A5A5 !important",
      borderWidth: "1px !important",
    },
    "&:after": {
      borderColor: "#A5A5A5",
      borderWidth: "1px !important",
    },
  },
  underlineError: {
    borderRadius: 5,
    "&:after": {
      borderColor: dangerColor[0],
    },
  },
  underlineSuccess: {
    borderRadius: 5,
    "&:after": {
      borderColor: successColor[0],
    },
  },
  borderClass: {
    border: "1px solid #A5A5A5",
    backgroundColor: "transparent",
    borderRadius: 5,
    paddingLeft: 5,
    paddingRight: 5,
  },
  labelRoot: {
    ...defaultFont,
    color: grayColor[1] + " !important",
    fontWeight: "400",
    fontSize: "13px",
    lineHeight: "0.8",
    letterSpacing: "unset",
    transform: "none !important",
  },
  labelRootError: {
    color: dangerColor[0] + " !important",
  },
  labelRootSuccess: {
    color: successColor[0] + " !important",
  },
  feedback: {
    position: "absolute",
    top: "18px",
    right: "0",
    zIndex: "2",
    display: "block",
    width: "24px",
    height: "24px",
    textAlign: "center",
    pointerEvents: "none",
  },
  marginTop: {
    marginTop: "16px",
  },
  formControl: {
    paddingBottom: "10px",
    // margin: "27px 0 0 0",
    position: "relative",
    verticalAlign: "unset",
  },
  mt20: {
    marginTop: "12px !important",
  },
  mt0: {
    marginTop: "0px !important",
  },
  erroBorderClass: {
    border: "1px solid red",
    marginTop: "10px",
    borderRadius: "15%",
  },
});

export default customInputStyle;
